import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SearchDistrictMasterComponent } from './search-district-master/search-district-master.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Country, District, State } from 'app/masters/models/branch-master.model';
import { LocationService } from '../location.service';

@Component({
  selector: 'app-district-master',
  templateUrl: './district-master.component.html',
  styleUrls: ['./district-master.component.scss']
})
export class DistrictMasterComponent implements OnInit {
  popbutton:number;
  distictForm: FormGroup;
  enabledisablebtn:boolean =false;
  activeCountry: Country[] = [];
  activeState: State[] = [];
  filteredCountryArray: Observable<any[]>;
  filteredStateArray: Observable<any[]>;
  fkCountryId: FormControl;
  fkStateId: FormControl;
  countryIndex = [];
  stateIndex = [];
  SavingPayLoad: any;
  countryName: string;
  stateName: string;
  disabled = true;
  selectdistictObj:any={};
  private distictArray:District[]=[];
  countryData: any;
  stateData: any;
  constructor(public dialog: MatDialog, public locationService: LocationService,private _fb: FormBuilder,public dialogRef: MatDialogRef<DistrictMasterComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) { 
    dialogRef.disableClose = true;
    this.getCountryList();
  }

  ngOnInit(): void {
    this.getdistrictList();
    this.enabledisablebtn=true;
    this.popbutton =0;
    this.loadDistictForm();
    this.countryControll();
    this.StateControll();
    this.countryIndex = [];
    this.stateIndex = [];
    if(this.data.id !=null && this.data.id !=undefined){
      this.popbutton =this.data.id;
    }
  }
  getdistrictList() {  
    this.locationService.getDistrict(0).subscribe(data => {
      this.distictArray=[];
      this.distictArray = data 
    });
  }

   /* Get Country APi */
   getCountryList() {
    this.locationService.getCountry().subscribe(data => {
      let countryListActive = data;
      this.countryData = data
      for (var _i = 0; _i < countryListActive.length; _i++) {
        if (countryListActive[_i].isActive == true) {
          this.countryIndex.push(countryListActive[_i]);
          this.activeCountry = this.countryIndex;
        }
      }
      this.countryControll();
    });
  }
  countryControll() {
    this.fkCountryId = new FormControl();
    this.filteredCountryArray = this.fkCountryId.valueChanges
      .pipe(
        startWith(''),
        map(country => country ? this.filterCountryfunction(country) : this.activeCountry.slice())
      );
  }

  filterCountryfunction(name: string) {
    return this.activeCountry.filter(country =>
      country.countryName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }
  StateControll() {
    this.fkStateId = new FormControl();
    this.filteredStateArray = this.fkStateId.valueChanges
      .pipe(
        startWith(''),
        map(State => State ? this.filterStatefunction(State) : this.activeState.slice())
      );
  }

  filterStatefunction(name: string) {
    return this.activeState.filter(State =>
      State.stateName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }
  saveDistrictForm(event) {   
    debugger 
    let stateId
    let statecode
    const form = this.distictForm.controls;
    console.log( this.distictForm.controls , "fomrmrmrmm")
    
    let countryname = this.countryData.filter(item => item.countryName == form.fkCountryId.value);
    if (countryname.length == 0) {
      this.locationService.openSnackBar("Please select a valid country", "OK");
      return;
    }
   
    let statename = this.stateData.filter(item => item.stateName == form.fkStateId.value);
    if(statename.length==0){
      this.locationService.openSnackBar("Please select valid state", "OK");
      return; 
    }
    stateId = statename[0].pkStateId;
    statecode =statename[0].sateCode;
   
    if (form.pkDistrictId.value === 0) {
      const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
      button.setAttribute('disabled', true);
      this.SavingPayLoad = {
      districtname: form.districtname.value,
      fkStateId: stateId,
      sateCode:statecode,
      isActive: form.isActive.value,
      PkDistrictId: 0
    }
      delete this.SavingPayLoad.pkDistrictId;
      this.locationService.addDistrictMaster(this.SavingPayLoad).subscribe(data => {
        if (data.statusCode == 1) {
          this.locationService.openSnackBar("Record Saved Successfully ", "OK");
          this.resetForm();
          this.getdistrictList();
        }
      },
      err => {
        if (err.status == 403) {
          this.locationService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.locationService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.locationService.openSnackBar("API Failed", "OK");
        }
      }
    );
    } else {
      const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
      button.setAttribute('disabled', true);
      this.SavingPayLoad = {
        districtname: form.districtname.value,
        fkStateId: stateId,
        sateCode:statecode,
        isActive: form.isActive.value,
        PkDistrictId: form.pkDistrictId.value
      }
      this.locationService.addDistrictMaster(this.SavingPayLoad).subscribe(data => {
        if (data.statusCode == 1) {
          this.locationService.openSnackBar("Record Updated Successfully " , "OK");
          this.resetForm();
          this.getdistrictList();
        }
      },
      err => {
        if (err.status == 403) {
          this.locationService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.locationService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.locationService.openSnackBar("API Failed", "OK");
        }
      }
    );
    }
  }

  loadDistictForm() {
    this.enabledisablebtn=true;
    this.distictForm = this._fb.group({
      pkDistrictId: 0,
      fkCountryId: ['', [Validators.required]],
      districtname: [{ value: '', disabled: this.disabled }, [Validators.required]],
      fkStateId: [{ value: '', disabled: true }, [Validators.required]],
      stateName: [{ value: '', disabled: true }, Validators.required],
      isActive: false,
      countryName: '',
      sateCode:''
    });
  }
  setupdateCityForm(objdata:any) {
   
      this.distictForm.patchValue(
        {
          pkDistrictId: objdata.pkDistrictId,
          fkCountryId: objdata.countryName,
          districtname: objdata.districtname,
          fkStateId: objdata.stateName,
          isActive: objdata.isActive
          // pkSynchId: selectedCitydata.pkSynchId
        });
      
      this.changeCountry(objdata.fkCountryId);
      this.stateSelect(objdata.fkStateId);

  }
  changeCountry(eventId, isManual: boolean = false) {
    this.enableButton(eventId);
    let selectedCountry = eventId;
    this.stateIndex = [];
    this.activeState = [];
   
    this.locationService.getState().subscribe(data => {
      let StateActive = data;
      this.stateData = data;
      for (var i = 0; i < StateActive.length; i++) {
        if (StateActive[i].isActive == true && StateActive[i].fkCountryId == selectedCountry) {
          this.stateIndex.push(StateActive[i]);
          this.activeState = this.stateIndex;
          this.distictForm.controls.fkStateId.enable();
        }
      }
      if (isManual) {
        this.StateControll();
        this.distictForm.patchValue(
          {
            districtname: '',
            fkStateId: null,
            isActive: false
          });
      }
    });
  }
  changeState(sid:any,type:any){
    this.distictForm.controls.districtname.enable();
    this.distictForm.patchValue(
      {
        districtname: '',
        isActive: false
      });
  }
  
  stateSelect(e){
    this.enableButton(e);
      }
  enableButton($event){    
    const form = this.distictForm.controls;
    if(form.fkCountryId.value == '' || form.fkStateId.value == '' || form.districtname.value == ''){
      this.enabledisablebtn= true;
    }else{
      this.enabledisablebtn=false;
    }
  }
  resetForm() {
    this.loadDistictForm();
    this.stateIndex = [];
    this.countryIndex = [];
    this.disabled = true;
    this.countryName = '';
  }
  closedailog(){
    this.dialogRef.close();
  }

   /** Search District Master */
   searchDistrictMaster() {
    const dialogRef = this.dialog.open(SearchDistrictMasterComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "50%",
      width: "50%",
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
    
      this.selectdistictObj = result
      if (this.selectdistictObj != null) {
        this.enabledisablebtn=false;
        this.setupdateCityForm(this.selectdistictObj);
        this.distictForm.controls.districtname.enable();
      }
    });
  }
}
